import { module } from 'modujs'
import { html } from '../utils/environment'

export default class extends module {
    constructor(m) {
        super(m)

        // Binding
        this.onEnterBinding = this.onEnter.bind(this)
        this.onLeaveBinding = this.onLeave.bind(this)

        // UI
        this.$el = this.el
        this.$items = this.$('item')
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.bindEvents()
    }

    destroy() {
        super.destroy()
        this.unbindEvents()
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
       let index = 0
       while (index < this.$items.length) {
           const $item = this.$items[index]
           $item.addEventListener('mouseenter', this.onEnterBinding)
           $item.addEventListener('mouseleave', this.onLeaveBinding)
           index++
       } 
    }

    unbindEvents() {
        let index = 0
       while (index < this.$items.length) {
           const $item = this.$items[index]
           $item.removeEventListener('mouseenter', this.onEnterBinding)
           $item.removeEventListener('mouseleave', this.onLeaveBinding)
           index++
       } 
    }

    ///////////////
    // Callbacks
    ///////////////
    onEnter(e) {
        const $target = e.target
        $target.classList.add('is-active')

        html.classList.add('has-project-list-hover')
    }
    
    onLeave(e) {
        const $target = e.target
        $target.classList.remove('is-active')

        html.classList.remove('has-project-list-hover')
    }

    ///////////////
    // Methods
    ///////////////
}